import { formatStationAsset } from 'modules/Analytics/legacyHelpers';

export const getTopHit = bestMatch => {
  const topHit = Array.isArray(bestMatch) ? bestMatch[0] : bestMatch;

  const { artistId, artistName, callLetters, catalogId, catalogType, contentType, id, title } =
    topHit || {};

  return catalogId
    ? formatStationAsset({
        artistId: catalogType === 'track' ? catalogId : artistId,
        artistName: catalogType === 'track' ? title : artistName,
        callLetters,
        id: catalogType === 'track' ? undefined : catalogId,
        name: catalogType === 'track' ? undefined : title,
        type: catalogType,
      })
    : {
        id: `${contentType}|${id}`,
        name: title,
      };
};
